import React from 'react'

function IconSheets() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="47" height="50" fill="none" viewBox="0 0 47 50">
      <path
        fill="#13682B"
        fillRule="evenodd"
        d="M10.504 8.354v33.262h25.992V16.224l-.175-.195-7.483-7.5-.195-.175h-18.14zm1.247 1.25h16.016v7.5h7.482v23.262H11.751V9.603zm17.263.898l5.339 5.351h-5.34v-5.351zM17.46 24.004v1.25h11.487v-1.25H17.46zm0 3.75v1.25h8.993v-1.25H17.46zm0 3.75v1.25h11.487v-1.25H17.46z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#13682B"
        fillRule="evenodd"
        d="M14.311 20.168h18.116V37.89H14.31V20.168zm1.181 1.181v15.36h15.753v-15.36H15.492z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export default IconSheets
